import Login from "./pages/login";
import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import ActivationRequests from "./pages/activation-requests";
import {useContext} from "react";
import AuthContext from "./store/auth-context";
import ForgotPassword from "./pages/forgot-password";

function App() {
    const authCxt = useContext(AuthContext);
    const isLoggedIn = authCxt.isLoggedIn;

    const isNotLoggedInContent = (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/forgotPassword" element={<ForgotPassword isPassExpired={false} />} />
                <Route path="/passwordExpired" element={<ForgotPassword isPassExpired={true} />} />
                <Route path="*" element={<Navigate to="/" replace={true} />} />
            </Routes>
        </BrowserRouter>
    );

    const isLoggedInContent = (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<ActivationRequests />} />
            </Routes>
        </BrowserRouter>
    );

    return (
    <div className="App" style={{height: "100%"}}>
        {isLoggedIn && isLoggedInContent}
        {!isLoggedIn && isNotLoggedInContent}
    </div>
    );
}

export default App;
